import { IStoreIndex } from "services/indexdb/interface/istore-index";

const Fields = {
    Name: 'rds_id',
    Path: 'id'
}

export const RdsIdUnique: IStoreIndex = {
    Name: Fields.Name,
    Path: Fields.Path,
    Unique: true
}

export const RdsId: IStoreIndex = {
    Name: Fields.Name,
    Path: Fields.Path,
    Unique: false
}